import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import Header from './Header';
import Add from './Add';
import logo from './images/logo (1).png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faHotel, faBuilding,faMoneyBillAlt, faBed, faCoffee } from '@fortawesome/free-solid-svg-icons';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar__logo">
          <img className="logooyo" src={logo} alt="logos" />
        </div>
        <ul className={`navbar__menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <li className="navbar__menu-item">
            <Link to="/">
              <FontAwesomeIcon icon={faHome} />
              <h3 className="navbar__menu-text">Home</h3>
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/hotels">
              <FontAwesomeIcon icon={faHotel} />
              <h3>Hotels</h3>
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/property">
              <FontAwesomeIcon icon={faBuilding} />
              <h3>property</h3>
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/resturent">
              <FontAwesomeIcon icon={faMoneyBillAlt} />
              <h3>rant$</h3>
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/services">
              <FontAwesomeIcon icon={faBed} />
              <h3>flats</h3>
            </Link>
          </li>
          <li className="navbar__menu-item">
            <Link to="/chat">
              <FontAwesomeIcon icon={faCoffee} />
              <h3>rooms</h3>
            </Link>
          </li>
        </ul>
        <div className="navbar__actions">
          <button className="navbar__login">
            <Link to="/login">Login</Link>
          </button>
          <button className="navbar__signup">
            <Link to="/signup">Signup</Link>
          </button>
        </div>
        <div className="navbar__mobile-toggle" onClick={toggleMobileMenu}></div>
      </nav>
      <Add />
      <Header />
    </>
  );
}

export default Navbar;
